var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bounce"}},[(_vm.show)?_c('div',{staticClass:"mofu-warning"},[_c('article',{staticClass:"message is-danger"},[_c('div',{staticClass:"message-body message-content"},[_vm._v("\n        🔥 发生错误: "),_c('br'),_vm._v("\n        "+_vm._s(_vm.warn)+"\n      ")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0128350e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Warning.vue
// module id = null
// module chunks = 